<script lang="ts">
	import { MoreFromThisCollectionSection } from '../../components/MoreFromThisCollectionSection';
	import { getBookCrumbs } from '../../utils/getBookCrumbs/getBookCrumbs';
	import { getLink } from '../../utils/getBookLink/getBookLink';
	import { BookPdpDescription } from './BookPdpDescription';
	import { BookRelatedItems } from './BookRelatedItems';
	import { getGallery } from './utils/getGallery/getGallery';
	import { getBookJsonLd } from '#lib/features/seo/utils/getBookJsonLd/getBookJsonLd.js';
	import { page } from '$app/state';
	import { Breadcrumbs } from '$global/components/Breadcrumbs';
	import { Container } from '$global/components/Container';
	import { PdpGallery } from '$global/features/pdp/components/PdpGallery';
	import { JsonLd } from '$global/features/seo/components/JsonLd';
	import type { ShopBooksPDPPageData } from '$routes/shop/books/[slug]/types';

	let book = $derived(page.data.book as ShopBooksPDPPageData['book']);
	let shopCollection = $derived(
		page.data.shopCollection as ShopBooksPDPPageData['shopCollection']
	);

	let series = $derived(page.data.series as ShopBooksPDPPageData['series']);
	let crumbs = $derived(getBookCrumbs(book, series));
	let gallery = $derived(getGallery(book));
	// A cover of a series is represented by the series page's JSON-LD.
	let jsonLd = $derived(
		book && !series
			? getBookJsonLd(book, getLink(false, book.slug as string))
			: null
	);
	let merchItems = $derived(shopCollection?.merch_items);
	let books = $derived(shopCollection?.publishing_books);

	const dataCy = 'publishing-pdp';
	let selectedItemIndex = $state(0);
	let isLightboxOpen = $state(false);
</script>

{#if jsonLd}
	<JsonLd data={jsonLd} />
{/if}

<Breadcrumbs {dataCy} {crumbs} class="mb-[3.25rem] lg:mb-[5.25rem]" />
<Container
	{dataCy}
	class="mb-[4rem] sm:mb-[3rem] lg:mb-[7.55rem] lg:flex lg:lg:gap-10"
>
	<PdpGallery
		bind:selectedItemIndex
		bind:isLightboxOpen
		{dataCy}
		class="lg:w-1/2"
		items={gallery}
	/>
	<BookPdpDescription
		{dataCy}
		class="lg:w-1/2"
		bind:selectedItemIndex
		bind:isLightboxOpen
		{getLink}
	/>
</Container>

{#if shopCollection}
	<Container dataCy="more-from-this-collection">
		<MoreFromThisCollectionSection
			{merchItems}
			{books}
			collectionName={shopCollection.title}
			collectionSlug={shopCollection.slug}
			slugToExclude={`${book.slug}`}
		/>
	</Container>
{/if}

<BookRelatedItems {dataCy} />
